// pathpal-custom.js
document.addEventListener('DOMContentLoaded', () => {
  // Only run on PathPal product page
  if (document.body.classList.contains('template-product-custom-pathpal')) {
    // Wait a brief moment to ensure all elements are fully loaded
    setTimeout(() => {
      // Leave header/announcement bar alone - only target main content
      const mainContent = document.getElementById('MainContent');
      if (mainContent) {
        // Find all product-specific sections to fix
        const productSections = mainContent.querySelectorAll(
          '.shopify-section--main-product-custom-pathpal, ' +
          '.shopify-section--custom-reviews-pathpal, ' +
          '.shopify-section--custom-how-it-works-pathpal, ' +
          '.shopify-section--custom-imagine-next-round-pathpal, ' +
          '.shopify-section--custom-faq-pathpal, ' +
          '.shopify-section--custom-comparison-pathpal'
        );
        
        productSections.forEach(section => {
          // Fix main font sizes without affecting Dawn theme headers
          const textElements = section.querySelectorAll(
            'p, .benefit-tick, .review-card p, .faq-question, .faq-answer p'
          );
          
          textElements.forEach(el => {
            el.style.fontSize = '16px';
            el.style.lineHeight = '1.5';
          });
          
          // Fix the product title and headings
          section.querySelectorAll('h1, .text-3xl, .text-4xl').forEach(el => {
            el.style.fontSize = '30px';
          });
          
          // Fix form elements specifically
          section.querySelectorAll('select, option').forEach(el => {
            el.style.fontSize = '16px';
          });
          
          // Fix section titles with their proper sizes
          section.querySelectorAll('.section-title').forEach(el => {
            el.style.fontSize = window.innerWidth >= 768 ? '44px' : '36px';
          });
          
          // Fix section subtitles
          section.querySelectorAll('.section-subtitle').forEach(el => {
            el.style.fontSize = '18px';
            el.style.lineHeight = '1.6';
          });
        });
      }
    }, 100); // Small delay to ensure DOM is fully loaded
  }

  // --- PathPal Global Helper Functions ---
  const formatMoneyPathPal = (cents, currencySymbol = '$') => {
    if (typeof cents === 'string') cents = parseFloat(cents.replace(/[^0-9.-]+/g,""));
    else cents = parseFloat(cents);
    if (isNaN(cents)) cents = 0;
    let value = (cents / 100.0).toFixed(2);
    if (typeof window.Shopify !== 'undefined' && window.Shopify.currency && window.Shopify.currency.active) {
        currencySymbol = window.Shopify.currency.symbol || currencySymbol;
    } else if (typeof window.pathPalProductData !== 'undefined' && window.pathPalProductData.shopifyCurrency) {
        currencySymbol = window.pathPalProductData.shopifyCurrency;
    }
    return currencySymbol + value;
  };

// Fix CTA buttons specifically
document.querySelectorAll('.cta-button, .pathpal-main-atc-button, button.cta-button').forEach(button => {
  button.style.fontSize = '18px';
  
  // Also fix the text inside the button if it's in a span
  const buttonText = button.querySelector('.pathpal-atc-button-text');
  if (buttonText) {
    buttonText.style.fontSize = '18px';
  }
});
  
  // --- Product Variant Logic ---
  const productFormElement = document.getElementById('pathpal-product-form');
  if (productFormElement && typeof window.pathPalProductData !== 'undefined' && window.pathPalProductData.product) {
    const product = window.pathPalProductData.product;
    console.log("PathPal Product Data:", product); // Log product data

    if (!product || !product.variants || product.variants.length === 0) {
        console.error("PathPal Error: Product data or variants are missing.");
        return; // Stop if no product/variants
    }

    const currentVariantIdInput = productFormElement.querySelector('input[name="id"]');
    const priceElement = document.getElementById('pathpal-product-price');
    const comparePriceElement = document.getElementById('pathpal-product-compare-price');
    const savePercentElement = document.getElementById('pathpal-product-save-badge');
    const mainAtcButton = productFormElement.querySelector('.pathpal-main-atc-button');
    const mainAtcButtonText = mainAtcButton ? mainAtcButton.querySelector('.pathpal-atc-button-text') : null;
    const mainImageElement = document.getElementById('pathpal-main-product-image');
    const optionSelectors = productFormElement.querySelectorAll('.pathpal-variant-selector');

    const stickyBarElement = document.getElementById('pathpal-sticky-atc-bar');
    const stickyAtcImage = stickyBarElement ? stickyBarElement.querySelector('.pathpal-sticky-atc-image') : null;
    const stickyAtcTitle = stickyBarElement ? stickyBarElement.querySelector('.pathpal-sticky-atc-title') : null;
    const stickyAtcPrice = stickyBarElement ? stickyBarElement.querySelector('.pathpal-sticky-atc-variant-price') : null;
    const stickyAtcComparePrice = stickyBarElement ? stickyBarElement.querySelector('.pathpal-sticky-atc-compare-price') : null;
    const stickyAtcButton = stickyBarElement ? stickyBarElement.querySelector('.pathpal-sticky-atc-submit-button') : null;
    const stickyAtcButtonText = stickyAtcButton ? stickyAtcButton.querySelector('.pathpal-sticky-atc-button-text') : null;

    const finalCtaButton = document.querySelector('.pathpal-final-cta-button[form="pathpal-product-form"]');
    const finalCtaButtonText = finalCtaButton ? finalCtaButton.querySelector('.pathpal-final-cta-button-text') : null;

    function getSelectedVariant() {
      if (optionSelectors.length === 0 && product.variants.length === 1) {
        return product.variants[0]; // Handle single variant products with no selectors
      }
      let selectedOptions = [];
      optionSelectors.forEach(selector => {
        selectedOptions.push(selector.value);
      });
      const foundVariant = product.variants.find(variant => {
        if (!variant.options || variant.options.length !== selectedOptions.length) return false;
        return variant.options.every((option, index) => option === selectedOptions[index]);
      });
      console.log("Selected Options:", selectedOptions, "Found Variant:", foundVariant);
      return foundVariant;
    }

    function updateProductInfo(variant) {
      console.log("updateProductInfo called with variant:", variant); // Log the variant being processed

      if (!variant || typeof variant.id === 'undefined') {
        console.error("PathPal Error: updateProductInfo called with invalid variant.", variant);
        // Fallback: Disable ATC buttons if variant is invalid
        if (mainAtcButton) mainAtcButton.disabled = true;
        if (mainAtcButtonText) mainAtcButtonText.textContent = "Unavailable";
        if (stickyAtcButton) stickyAtcButton.disabled = true;
        if (stickyAtcButtonText) stickyAtcButtonText.textContent = "Unavailable";
        if (finalCtaButton) finalCtaButton.disabled = true;
        if (finalCtaButtonText) finalCtaButtonText.textContent = "Unavailable";
        // Optionally update price display to show "Unavailable" or clear it
        if(priceElement) priceElement.textContent = "N/A";
        if(comparePriceElement) comparePriceElement.style.display = 'none';
        if(savePercentElement) savePercentElement.style.display = 'none';
        return; // Critical: Stop further processing if variant is invalid
      }

      if(currentVariantIdInput) currentVariantIdInput.value = variant.id;

      if (priceElement) priceElement.textContent = formatMoneyPathPal(variant.price);
      if (comparePriceElement) {
        if (variant.compare_at_price > variant.price) {
          comparePriceElement.textContent = formatMoneyPathPal(variant.compare_at_price);
          comparePriceElement.style.display = '';
          if (savePercentElement) {
            const saving = Math.round(((variant.compare_at_price - variant.price) * 100.0) / variant.compare_at_price);
            savePercentElement.innerHTML = `SAVE ${saving}%`;
            savePercentElement.style.display = '';
          }
        } else {
          comparePriceElement.style.display = 'none';
          if (savePercentElement) savePercentElement.style.display = 'none';
        }
      }

      const updateButtonState = (btn, btnTextEl, availableText, soldOutText, availableIconClass = '', soldOutIconClass = '') => {
        if (btn && btnTextEl) {
          const iconEl = btn.querySelector('i');
          if (variant.available) {
            btnTextEl.textContent = availableText;
            if (iconEl && availableIconClass) { iconEl.className = availableIconClass; iconEl.style.display = '';}
            else if (iconEl) { iconEl.style.display = 'none'; } // Hide icon if no class specified for available state
            btn.disabled = false;
            btn.classList.remove('disabled');
          } else {
            btnTextEl.textContent = soldOutText;
            if (iconEl && soldOutIconClass) { iconEl.className = soldOutIconClass; iconEl.style.display = ''; }
            else if (iconEl) { iconEl.style.display = 'none'; } // Hide icon if no class specified for sold out state
            btn.disabled = true;
            btn.classList.add('disabled');
          }
        }
      };

      // Assuming 'product.title' is globally available from pathPalProductData or accessible differently
      const productTitleForButton = (typeof product !== 'undefined' && product.title) ? product.title : "Product";

      updateButtonState(mainAtcButton, mainAtcButtonText, "YES! I Want A Consistent Swing!", "Sold Out", "fas fa-cart-plus mr-2");
      if (finalCtaButton) {
          updateButtonState(finalCtaButton, finalCtaButtonText, `Claim My ${productTitleForButton} & Lock In My Discount!`, "Sold Out", "fas fa-check-double mr-2");
      }
      if (stickyAtcButton) {
          updateButtonState(stickyAtcButton, stickyAtcButtonText, "Add To My Bag", "Sold Out", "fas fa-arrow-right ml-1 sm:ml-2");
      }

      if (mainImageElement) {
        const imageToUse = variant.featured_image || (product ? product.featured_image : null);
        if (imageToUse && imageToUse.src) {
          mainImageElement.src = imageToUse.src;
          mainImageElement.alt = imageToUse.alt || (product ? product.title : "Product Image");
          const allThumbnails = document.querySelectorAll('#pathpal-thumbnail-images img');
          allThumbnails.forEach(thumb => {
            thumb.classList.toggle('active-thumbnail', thumb.dataset.mediaId == imageToUse.id);
          });
        } else {
            console.warn("No image found for main display for variant:", variant);
        }
      }

      if (stickyBarElement) { // Ensure stickyBarElement itself exists
        if (stickyAtcImage) {
            const stickyImageToUse = variant.featured_image || (product ? product.featured_image : null);
            if (stickyImageToUse && typeof stickyImageToUse.src === 'string') {
                try {
                    let baseSrc = stickyImageToUse.src.split('?')[0];
                    let queryParams = stickyImageToUse.src.split('?')[1] || '';
                    baseSrc = baseSrc.replace(/_(\d+)x(\d+)(_crop_center)?\.(jpg|jpeg|png|gif|webp)/i, ''); // More robustly remove existing size and extension
                    
                    const extensionMatch = stickyImageToUse.src.match(/\.(jpg|jpeg|png|gif|webp)/i);
                    const extension = extensionMatch ? extensionMatch[0] : '.jpg'; // Default to .jpg if no extension found

                    stickyAtcImage.src = `${baseSrc}_100x100_crop_center${extension}${queryParams ? '?' + queryParams : ''}`;
                } catch (e) {
                    console.warn("Could not resize sticky ATC image URL:", stickyImageToUse.src, e);
                    if (stickyImageToUse.src) stickyAtcImage.src = stickyImageToUse.src;
                }
                stickyAtcImage.alt = stickyImageToUse.alt || (product ? product.title : "Product Image");
            } else {
                 console.warn("No image or valid src for sticky ATC for variant:", variant);
            }
        }
        if (stickyAtcTitle && product) stickyAtcTitle.textContent = product.title;
        if (stickyAtcPrice) stickyAtcPrice.textContent = formatMoneyPathPal(variant.price);
        if (stickyAtcComparePrice) {
            if (variant.compare_at_price > variant.price) {
            stickyAtcComparePrice.textContent = formatMoneyPathPal(variant.compare_at_price);
            stickyAtcComparePrice.style.display = '';
            } else {
            stickyAtcComparePrice.style.display = 'none';
            }
        }
      }


      // Update URL only if variant.id is valid
      if (variant && typeof variant.id !== 'undefined') {
        const url = new URL(window.location.href); // Use window.location.href for safety
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      } else {
        console.warn("PathPal: Not updating URL, variant ID is undefined.");
      }
    } // End updateProductInfo

    optionSelectors.forEach(selector => {
      selector.addEventListener('change', () => {
        const selectedVariant = getSelectedVariant();
        updateProductInfo(selectedVariant);
      });
    });

    // Initial update
    let initialVariant;
    const urlVariantId = new URLSearchParams(window.location.search).get('variant');

    if (urlVariantId) {
        initialVariant = product.variants.find(v => v.id == urlVariantId);
        console.log("Variant from URL:", initialVariant);
    }

    if (!initialVariant) {
        // Try to find the first available variant
        initialVariant = product.variants.find(v => v.available);
        console.log("First available variant:", initialVariant);
    }

    if (!initialVariant && product.variants.length > 0) {
        // Fallback to the very first variant if none are explicitly selected or available
        initialVariant = product.variants[0];
        console.log("Fallback to first variant:", initialVariant);
    }

    if (initialVariant) {
        if (initialVariant.options && optionSelectors.length === initialVariant.options.length) {
            initialVariant.options.forEach((optionValue, index) => {
                if (optionSelectors[index]) {
                    optionSelectors[index].value = optionValue;
                }
            });
        }
        updateProductInfo(initialVariant);
    } else if (product.variants.length > 0 && product.has_only_default_variant) {
        // Handle products with only a default variant (no options)
        updateProductInfo(product.variants[0]);
    } else {
        console.error("PathPal Error: Could not determine an initial variant to display.");
        // Potentially call updateProductInfo with a null/undefined to set UI to "unavailable"
        updateProductInfo(undefined);
    }
  } else {
    console.warn("PathPal: Product form or product data not found. Variant JS not initialized.");
  } // End productFormElement check

  // --- FAQ Accordion ---
  const faqItems = document.querySelectorAll('.faq-item');
  faqItems.forEach(item => {
    const question = item.querySelector('.faq-question');
    const answer = item.querySelector('.faq-answer');
    const icon = item.querySelector('.faq-icon');
    if (question && answer && icon) {
      question.addEventListener('click', () => {
        const isOpen = answer.classList.contains('open');
        answer.classList.toggle('open');
        icon.classList.toggle('open');
        icon.classList.toggle('fa-plus', isOpen);
        icon.classList.toggle('fa-minus', !isOpen);
      });
    }
  });

  // --- Sticky ATC Bar Visibility ---
  const stickyBar = document.getElementById('pathpal-sticky-atc-bar');
  const mainProductInfoSectionForScroll = document.getElementById('pathpal-above-the-fold-content');
  let scrollThreshold = 800;
  if (mainProductInfoSectionForScroll) {
    scrollThreshold = mainProductInfoSectionForScroll.offsetTop + mainProductInfoSectionForScroll.offsetHeight;
  }
  if (stickyBar) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > scrollThreshold) {
        stickyBar.classList.add('visible');
      } else {
        stickyBar.classList.remove('visible');
      }
    }, { passive: true });
  }

  // --- Product Image Gallery Interaction ---
  const mainImgDisplay = document.getElementById('pathpal-main-product-image');
  const thumbnails = document.querySelectorAll('#pathpal-thumbnail-images img');
  if (mainImgDisplay && thumbnails.length > 0) {
    thumbnails.forEach(thumb => {
      thumb.addEventListener('click', () => {
        const newSrc = thumb.dataset.mainImageUrl;
        if (newSrc) {
          mainImgDisplay.src = newSrc;
          mainImgDisplay.alt = thumb.alt;
        }
        thumbnails.forEach(t => t.classList.remove('active-thumbnail'));
        thumb.classList.add('active-thumbnail');
      });
    });
  }

  // --- How It Works Tabs ---
  const tabLinks = document.querySelectorAll('.how-it-works-tabs .tab-link');
  const tabContents = document.querySelectorAll('.pathpal-how-it-works-content .tab-content');
  if (tabLinks.length > 0 && tabContents.length > 0) {
    tabLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const tabId = link.dataset.tab;
        tabLinks.forEach(l => l.classList.remove('active'));
        link.classList.add('active');
        tabContents.forEach(content => {
          content.classList.toggle('active', content.id === tabId);
        });
      });
    });
  }

  // --- Scroll Animations ---
  const animatedElements = document.querySelectorAll('.animate-on-scroll');
  if (animatedElements.length > 0) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animated');
        }
      });
    }, { threshold: 0.1 });
    animatedElements.forEach(el => observer.observe(el));
  }

  // --- Mobile Menu Toggle (PathPal Header specific) ---
  const mobileMenuButton = document.getElementById('pathpal-mobile-menu-button');
  const mobileMenu = document.getElementById('pathpal-mobile-menu');
  if (mobileMenuButton && mobileMenu) {
      mobileMenuButton.addEventListener('click', () => {
          mobileMenu.classList.toggle('hidden');
          const icon = mobileMenuButton.querySelector('i');
          if (mobileMenu.classList.contains('hidden')) {
              icon.classList.remove('fa-times'); icon.classList.add('fa-bars');
              mobileMenuButton.setAttribute('aria-label', 'Open Menu');
          } else {
              icon.classList.remove('fa-bars'); icon.classList.add('fa-times');
              mobileMenuButton.setAttribute('aria-label', 'Close Menu');
          }
      });
      mobileMenu.querySelectorAll('a').forEach(link => {
          link.addEventListener('click', () => {
              mobileMenu.classList.add('hidden');
              const icon = mobileMenuButton.querySelector('i');
              icon.classList.remove('fa-times'); icon.classList.add('fa-bars');
              mobileMenuButton.setAttribute('aria-label', 'Open Menu');
          });
      });
  }

  // Current Year for Footer (PathPal Footer specific)
  const currentYearEl = document.getElementById('pathpalCurrentYear');
  if (currentYearEl) {
      currentYearEl.textContent = new Date().getFullYear();
  }
});

// Add this to your existing pathpal-custom.js file or create a new script tag

document.addEventListener('DOMContentLoaded', function() {
    // Handle dynamic background image from section settings
    const heroSection = document.querySelector('.pathpal-hero-section');
    const bgImageUrl = heroSection.dataset.bgImage;
    if (bgImageUrl) {
        heroSection.style.backgroundImage = `url(${bgImageUrl})`;
    }
    
    // Handle variant changes for pricing display
    const variantRadios = document.querySelectorAll('.pathpal-diameter-option input[type="radio"]');
    const currentPriceEl = document.getElementById('pathpal-current-price');
    const originalPriceEl = document.getElementById('pathpal-original-price');
    const discountInfoEl = document.getElementById('pathpal-discount-info');
    const saleBadge = document.querySelector('.pathpal-sale-badge');
    const priceContainer = document.querySelector('.pathpal-price-info-container');
    const priceRowDisplay = document.querySelector('.pathpal-price-row-display');
    
    // Get product data from embedded JSON
    const productData = window.pathPalProductData?.product;
    const showSaveAsPercentage = document.querySelector('[data-show-save-percentage]')?.dataset.showSavePercentage === 'true';
    
    if (productData && variantRadios.length > 0) {
        variantRadios.forEach(radio => {
            radio.addEventListener('change', function() {
                // Find the variant that matches the selected options
                const selectedOptions = {};
                const allRadios = document.querySelectorAll('.pathpal-diameter-option input[type="radio"]:checked');
                
                allRadios.forEach(r => {
                    const optionName = r.name.replace('options[', '').replace(']', '');
                    selectedOptions[optionName] = r.value;
                });
                
                // Find matching variant
                const matchingVariant = productData.variants.find(variant => {
                    return variant.options.every((option, index) => {
                        const optionName = productData.options[index];
                        return selectedOptions[optionName] === option;
                    });
                });
                
                if (matchingVariant) {
                    updatePriceDisplay(matchingVariant);
                    // Update hidden variant ID
                    document.querySelector('input[name="id"]').value = matchingVariant.id;
                }
            });
        });
    }
    
    function updatePriceDisplay(variant) {
        const currentPrice = formatMoney(variant.price);
        const comparePrice = variant.compare_at_price ? formatMoney(variant.compare_at_price) : null;
        
        currentPriceEl.textContent = currentPrice;
        
        if (comparePrice && variant.compare_at_price > variant.price) {
            // Show sale pricing
            originalPriceEl.textContent = comparePrice;
            originalPriceEl.style.display = 'inline';
            
            if (showSaveAsPercentage) {
                const percentSaved = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
                discountInfoEl.textContent = `SAVE ${percentSaved}%`;
            } else {
                const dollarsSaved = formatMoney(variant.compare_at_price - variant.price);
                discountInfoEl.textContent = `SAVE ${dollarsSaved}`;
            }
            
            discountInfoEl.style.display = 'block';
            if (saleBadge) saleBadge.style.display = 'block';
            
            currentPriceEl.classList.remove('pathpal-no-discount');
            priceRowDisplay.classList.remove('pathpal-no-sale');
        } else {
            // Hide sale pricing
            originalPriceEl.style.display = 'none';
            discountInfoEl.style.display = 'none';
            if (saleBadge) saleBadge.style.display = 'none';
            
            currentPriceEl.classList.add('pathpal-no-discount');
            priceRowDisplay.classList.add('pathpal-no-sale');
        }
    }
    
    function formatMoney(cents) {
        // Basic money formatting - adjust based on your shop's currency settings
        const currency = window.pathPalProductData?.shopifyCurrency || '$';
        return currency + (cents / 100).toFixed(2);
    }
});

// Update sticky bar visibility based on scroll position
window.addEventListener('scroll', function() {
    const heroSection = document.querySelector('.pathpal-hero-section');
    const stickyBar = document.getElementById('pathpal-sticky-atc-bar');
    
    if (heroSection && stickyBar) {
        const heroBottom = heroSection.offsetTop + heroSection.offsetHeight;
        const scrollPosition = window.pageYOffset + window.innerHeight;
        
        if (scrollPosition > heroBottom + 200) {
            stickyBar.classList.add('visible');
        } else {
            stickyBar.classList.remove('visible');
        }
    }
});


// START: FlexiGuard Advantages Section Logic
// ==========================================================================
function initializeFlexiGuardAdvantagesSection(sectionElement) {
    console.log('%cFlexiGuard Init: Attempting to initialize section:', 'color: blue; font-weight: bold;', sectionElement);
    console.log('FlexiGuard Init: sectionElement.id is:', sectionElement.id);

    let derivedSectionId;

    // The script tag inside the section has an ID like "flexiguard-benefits-data-{{ section.id }}"
    // We need to find this script tag *within the current sectionElement*
    // and extract the {{ section.id }} part from its ID.
    const dataScriptSelector = 'script[id^="flexiguard-benefits-data-"]';
    const benefitsDataScriptElement = sectionElement.querySelector(dataScriptSelector);

    if (benefitsDataScriptElement) {
        console.log('FlexiGuard Init: Found data script element:', benefitsDataScriptElement);
        // Extract the part after "flexiguard-benefits-data-"
        derivedSectionId = benefitsDataScriptElement.id.substring("flexiguard-benefits-data-".length);
        console.log('FlexiGuard Init: Derived sectionId from data script ID:', derivedSectionId);
    } else {
        console.error('FlexiGuard Init ERROR: Could not find data script element with selector: ' + dataScriptSelector + ' within section:', sectionElement);
        const contentContainer = sectionElement.querySelector('[id^="flexiguard-benefits-content-"]');
        if (contentContainer && (!contentContainer.hasChildNodes() || contentContainer.textContent.trim() === '')) {
             contentContainer.innerHTML = '<p class="text-center text-gray-500 p-4">Error: Section data script not found. Configuration might be incomplete.</p>';
        }
        return; // Stop initialization if we can't get the ID
    }

    if (!derivedSectionId || derivedSectionId.trim() === "") {
        console.error('FlexiGuard Init ERROR: Derived sectionId is empty or invalid.', derivedSectionId, 'Original element:', sectionElement);
        return;
    }

    const sectionId = derivedSectionId; // Use this for subsequent querySelectors
    console.log(`%cFlexiGuard Init [${sectionId}]: Using Section ID: ${sectionId}`, 'color: green; font-weight: bold;');

    const benefitsTabsContainer = sectionElement.querySelector(`#flexiguard-benefits-tabs-${sectionId}`);
    const benefitsContentContainer = sectionElement.querySelector(`#flexiguard-benefits-content-${sectionId}`);
    // benefitsDataScriptElement is already found

    if (!benefitsTabsContainer) {
        console.error(`FlexiGuard Init ERROR [${sectionId}]: Tabs container (#flexiguard-benefits-tabs-${sectionId}) not found.`);
        if (benefitsContentContainer) benefitsContentContainer.innerHTML = `<p class="text-center text-gray-500 p-4">Error: Tabs UI element missing for section ${sectionId}.</p>`;
        return;
    }
    if (!benefitsContentContainer) {
        console.error(`FlexiGuard Init ERROR [${sectionId}]: Content container (#flexiguard-benefits-content-${sectionId}) not found.`);
        // Can't display error in content container if it's missing
        return;
    }
    console.log(`FlexiGuard Init [${sectionId}]: All required containers (tabs, content) and script tag found.`);

    let benefitsData;
    try {
        benefitsData = JSON.parse(benefitsDataScriptElement.textContent);
        console.log(`FlexiGuard Init [${sectionId}]: Benefits data parsed:`, benefitsData);
    } catch (e) {
        console.error(`FlexiGuard Init ERROR [${sectionId}]: Could not parse benefits data. Error:`, e, "Raw content:", benefitsDataScriptElement.textContent);
        benefitsContentContainer.innerHTML = '<p class="text-center text-gray-500 p-4">Error loading advantages data. Check console for details.</p>';
        return;
    }

    if (!Array.isArray(benefitsData)) {
        console.error(`FlexiGuard Init ERROR [${sectionId}]: Parsed benefits data is not an array. Type: ${typeof benefitsData}`);
        benefitsContentContainer.innerHTML = '<p class="text-center text-gray-500 p-4">Advantage data is not in the correct format.</p>';
        return;
    }
    
    function renderRichText(htmlContent) {
        return htmlContent || "<p>Description not available.</p>";
    }

    function updateContent(benefit) {
        if (!benefit) {
            console.warn(`FlexiGuard Init [${sectionId}]: updateContent called with no benefit.`);
            return;
        }
        console.log(`FlexiGuard Init [${sectionId}]: Updating content for:`, benefit.title);

        benefitsContentContainer.classList.remove('flexiguard-animate-fade-in');
        void benefitsContentContainer.offsetWidth; 
        benefitsContentContainer.classList.add('flexiguard-animate-fade-in');

        const imageUrl = benefit.image_url || `https://placehold.co/600x400/E0E7FF/1F3F60?text=${encodeURIComponent(benefit.title || 'Image')}&font=inter`;
        const imageAlt = benefit.image_alt || benefit.title || "Benefit image";
        
        benefitsContentContainer.innerHTML = `
            <div class="mb-6 w-full h-64 overflow-hidden rounded-lg shadow-xl border border-gray-200 bg-gray-100">
                <img
                    src="${imageUrl}"
                    alt="${imageAlt}"
                    class="w-full h-full object-cover"
                    onerror="this.onerror=null; this.src='https://placehold.co/600x400/1F3F60/8CC63F?text=Image+Error&font=inter'; this.alt='Error loading image';"
                />
            </div>
            <h4 class="text-4xl font-extrabold text-gray-900 mb-4 leading-tight">${benefit.title || "Untitled Benefit"}</h4>
            <div class="text-lg text-gray-700 leading-relaxed">${renderRichText(benefit.description)}</div>
        `;
    }

    function renderTabs() {
        console.log(`FlexiGuard Init [${sectionId}]: Rendering tabs.`);
        benefitsTabsContainer.innerHTML = ''; 

        if (benefitsData.length === 0) {
            console.log(`FlexiGuard Init [${sectionId}]: No benefit items to render.`);
            benefitsContentContainer.innerHTML = '<p class="text-center text-gray-500 p-4">No advantages have been configured for this section. Please add "Advantage Item" blocks in the theme customizer.</p>';
            benefitsTabsContainer.innerHTML = '<p class="text-center text-xs text-gray-400 p-2">Add items in editor.</p>';
            return;
        }

        let firstButtonToClick = null;

        benefitsData.forEach((benefit, index) => {
            if (!benefit || typeof benefit.title === 'undefined') { 
                console.warn(`FlexiGuard Init [${sectionId}]: Skipping invalid benefit item at index ${index}:`, benefit);
                return; 
            }

            const button = document.createElement('button');
            button.className = 'flex items-center px-4 py-3 rounded-lg text-left font-semibold transition-all duration-300 ease-in-out group text-pathpal-blue'; // Tailwind classes

            const defaultIconSvg = '<svg class="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>';

            button.innerHTML = `
                <span class="mr-3 transition-transform duration-300 group-hover:scale-110">
                    ${benefit.icon_svg || defaultIconSvg}
                </span>
                ${benefit.title}
            `;

            button.addEventListener('click', () => {
                console.log(`FlexiGuard Init [${sectionId}]: Tab clicked:`, benefit.title);
                benefitsTabsContainer.querySelectorAll('button').forEach(btn => {
                    btn.classList.remove('bg-pathpal-blue', 'text-white', 'shadow-lg', 'transform', 'translate-x-1');
                    btn.classList.add('text-pathpal-blue'); 
                });

                button.classList.add('bg-pathpal-blue', 'text-white', 'shadow-lg', 'transform', 'translate-x-1');
                button.classList.remove('text-pathpal-blue'); 

                updateContent(benefit);
            });
            benefitsTabsContainer.appendChild(button);
            if (!firstButtonToClick) {
                firstButtonToClick = button;
            }
        });

        if (firstButtonToClick) {
            console.log(`FlexiGuard Init [${sectionId}]: Clicking first tab automatically.`);
            firstButtonToClick.click();
        } else {
            console.warn(`FlexiGuard Init [${sectionId}]: No valid buttons rendered to click for first tab.`);
             benefitsContentContainer.innerHTML = '<p class="text-center text-gray-500 p-4">No valid advantage items found to display.</p>';
        }
    }
    renderTabs();
}

function initAllFlexiGuardSections() {
    const advantageSections = document.querySelectorAll('.shopify-section--custom-flexiguard-advantages');
    console.log('FlexiGuard Init: Found sections:', advantageSections.length);
    advantageSections.forEach(sectionElement => {
        if (!sectionElement.dataset.flexiguardInitialized) {
            initializeFlexiGuardAdvantagesSection(sectionElement);
            sectionElement.dataset.flexiguardInitialized = 'true';
        } else {
            console.log('FlexiGuard Init: Section already initialized, skipping (ID from dataset):', sectionElement.dataset.sectionIdToVerify || 'N/A');
        }
    });
}

document.addEventListener('DOMContentLoaded', () => {
    console.log('FlexiGuard Init: DOMContentLoaded event.');
    initAllFlexiGuardSections();
});

document.addEventListener('shopify:section:load', function(event) {
    console.log('FlexiGuard Init: shopify:section:load event for target:', event.target);
    const targetElement = event.target;
    if (targetElement && typeof targetElement.matches === 'function' && targetElement.matches('.shopify-section--custom-flexiguard-advantages')) {
        // Reset initialization flag for the specific section being loaded/reloaded
        delete targetElement.dataset.flexiguardInitialized;
        initializeFlexiGuardAdvantagesSection(targetElement);
        targetElement.dataset.flexiguardInitialized = 'true';
    }
});

document.addEventListener('shopify:section:reorder', function(event) {
    console.log('FlexiGuard Init: shopify:section:reorder event.');
    // For reorder, it's safer to re-scan and initialize all.
    document.querySelectorAll('.shopify-section--custom-flexiguard-advantages').forEach(s => delete s.dataset.flexiguardInitialized);
    initAllFlexiGuardSections();
});

// Ensure it runs if the page loads very quickly and DOMContentLoaded has already fired.
if (document.readyState === "complete" || document.readyState === "interactive") {
    setTimeout(() => { 
        console.log('FlexiGuard Init: Document already complete/interactive, attempting init.');
        initAllFlexiGuardSections();
    }, 0);
}

// Enhanced FAQ Functionality for SEO-Optimized FAQ Section
// Add this to your existing pathpal-custom.js file

// Enhanced FAQ Logic (replaces the basic FAQ accordion section)
function initEnhancedFAQ() {
  const faqToggles = document.querySelectorAll('.faq-toggle');
  
  if (faqToggles.length === 0) {
    // Fallback to original FAQ logic if new structure not found
    const faqItems = document.querySelectorAll('.faq-item');
    faqItems.forEach(item => {
      const question = item.querySelector('.faq-question');
      const answer = item.querySelector('.faq-answer');
      const icon = item.querySelector('.faq-icon');
      if (question && answer && icon) {
        question.addEventListener('click', () => {
          const isOpen = answer.classList.contains('open');
          answer.classList.toggle('open');
          icon.classList.toggle('open');
          icon.classList.toggle('fa-plus', isOpen);
          icon.classList.toggle('fa-minus', !isOpen);
        });
      }
    });
    return;
  }
  
  faqToggles.forEach(function(toggle, index) {
    toggle.addEventListener('click', function() {
      const answer = this.nextElementSibling;
      const icon = this.querySelector('.faq-icon');
      const stateText = this.querySelector('.sr-only');
      const isExpanded = this.getAttribute('aria-expanded') === 'true';
      
      // Toggle ARIA states for accessibility
      this.setAttribute('aria-expanded', !isExpanded);
      answer.setAttribute('aria-hidden', isExpanded);
      
      // Toggle visual states
      if (isExpanded) {
        answer.classList.remove('open');
        icon.className = 'fas fa-plus faq-icon text-brand-lime text-xl transition-transform duration-300';
        if (stateText) stateText.textContent = 'Click to expand answer';
      } else {
        answer.classList.add('open');
        icon.className = 'fas fa-minus faq-icon text-brand-lime text-xl transition-transform duration-300 rotate-0';
        if (stateText) stateText.textContent = 'Click to collapse answer';
        
        // Analytics tracking for FAQ interactions
        if (typeof gtag !== 'undefined') {
          gtag('event', 'faq_expand', {
            'event_category': 'FAQ',
            'event_label': this.querySelector('.faq-question-text')?.textContent.trim() || 'FAQ Question',
            'question_index': index + 1
          });
        }
        
        // Alternative analytics for other tracking systems
        if (typeof dataLayer !== 'undefined') {
          dataLayer.push({
            'event': 'faq_interaction',
            'faq_question': this.querySelector('.faq-question-text')?.textContent.trim() || 'FAQ Question',
            'faq_action': 'expand',
            'faq_index': index + 1
          });
        }
      }
      
      // Auto-collapse other open FAQs (optional - remove if you want multiple open)
      faqToggles.forEach(function(otherToggle) {
        if (otherToggle !== toggle && otherToggle.getAttribute('aria-expanded') === 'true') {
          const otherAnswer = otherToggle.nextElementSibling;
          const otherIcon = otherToggle.querySelector('.faq-icon');
          const otherStateText = otherToggle.querySelector('.sr-only');
          
          otherToggle.setAttribute('aria-expanded', 'false');
          otherAnswer.setAttribute('aria-hidden', 'true');
          otherAnswer.classList.remove('open');
          otherIcon.className = 'fas fa-plus faq-icon text-brand-lime text-xl transition-transform duration-300';
          if (otherStateText) otherStateText.textContent = 'Click to expand answer';
        }
      });
    });
    
    // Enhanced keyboard navigation support
    toggle.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.click();
      } else if (e.key === 'ArrowDown') {
        e.preventDefault();
        const nextToggle = faqToggles[index + 1];
        if (nextToggle) nextToggle.focus();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        const prevToggle = faqToggles[index - 1];
        if (prevToggle) prevToggle.focus();
      }
    });
  });
  
  // Track FAQ section view with Intersection Observer
  const faqSection = document.getElementById('faq');
  if (faqSection && typeof IntersectionObserver !== 'undefined') {
    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          // Google Analytics 4 tracking
          if (typeof gtag !== 'undefined') {
            gtag('event', 'faq_section_view', {
              'event_category': 'FAQ',
              'event_label': 'FAQ Section Viewed',
              'engagement_time_msec': 1000
            });
          }
          
          // Google Tag Manager tracking
          if (typeof dataLayer !== 'undefined') {
            dataLayer.push({
              'event': 'section_view',
              'section_name': 'FAQ',
              'section_type': 'product_faq'
            });
          }
          
          observer.unobserve(entry.target);
        }
      });
    }, { 
      threshold: 0.5,
      rootMargin: '0px 0px -100px 0px'
    });
    
    observer.observe(faqSection);
  }
}

// Initialize enhanced FAQ when DOM is loaded
// (This should replace or be called instead of the basic FAQ logic)
document.addEventListener('DOMContentLoaded', function() {
  // Add a small delay to ensure all elements are rendered
  setTimeout(() => {
    initEnhancedFAQ();
  }, 100);
});

// Handle theme editor section reloads
document.addEventListener('shopify:section:load', function(event) {
  if (event.target.querySelector('.faq-section, .faq-list')) {
    setTimeout(() => {
      initEnhancedFAQ();
    }, 100);
  }
});

// ==========================================================================
// END: FlexiGuard Advantages Section Logic